import { NEW_MASCOTS } from '@daymade/common-lib/constants';

// Temporary mapping for legacy plasmic avatar URLs.
export const mascotMapping: Record<string, string> = {
  'https://site-assets.plasmic.app/1be4ecac547f167f89b52477bbfc0f80.png':
    NEW_MASCOTS[1],
  'https://site-assets.plasmic.app/2af9da864833104acef88d878ff48441.png':
    NEW_MASCOTS[1],
  'https://site-assets.plasmic.app/65c13415d8015ec78b236d8bd1c4dd5f.png':
    NEW_MASCOTS[2],
  'https://site-assets.plasmic.app/83b7e5def1c5f12de6bb03cf73bc9eb6.png':
    NEW_MASCOTS[2],
  'https://site-assets.plasmic.app/a35c7a43ca97c2c8f4b7dc1fe2284571.png':
    NEW_MASCOTS[3],
  'https://site-assets.plasmic.app/acbc2ab9157ee70eb758a4b3c6b7a858.png':
    NEW_MASCOTS[3],
  'https://site-assets.plasmic.app/bbfb732488054fa23336d142df19ebdf.png':
    NEW_MASCOTS[4],
  'https://site-assets.plasmic.app/f62915af26eb28527a4f2982028dc0ae.png':
    NEW_MASCOTS[4],
};

const mappedMascots = Object.values(mascotMapping);

export const getRandomMascotAvatar = () => {
  return mappedMascots[Math.floor(Math.random() * mappedMascots.length)];
};

export const resolveUserAvatar = ({
  avatarLocation,
  randomAvatar,
}: {
  avatarLocation?: string | null;
  randomAvatar: string;
}) => {
  const useNewAvatar =
    (avatarLocation && avatarLocation.includes('plasmic')) || !avatarLocation;

  if (useNewAvatar) {
    return avatarLocation
      ? (mascotMapping[avatarLocation] ?? randomAvatar)
      : randomAvatar;
  }

  return avatarLocation ?? randomAvatar;
};
